import { useMutation, useQueryClient } from "@tanstack/react-query";
import { settingsService } from "@/features/settings/services/settingsService";
import { handleApiError, toastMutationSuccess } from "@/lib/error-handler";
import { queryKeys } from "@/lib/query-keys";
import type {
  Settings,
  TestEmailRequest,
  TestEmailResponse,
  ToggleMaintenanceRequest,
  UpdateSettingsRequest,
} from "@/types/settings";

function invalidateSettings(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: queryKeys.settings.root() });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();
  return useMutation<Settings, Error, UpdateSettingsRequest>({
    mutationFn: (data) => settingsService.update(data),
    onSuccess: (res) => {
      invalidateSettings(queryClient);
      toastMutationSuccess(res, { fallbackMessage: "تم حفظ الإعدادات بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useToggleMaintenance() {
  const queryClient = useQueryClient();
  return useMutation<Settings, Error, ToggleMaintenanceRequest>({
    mutationFn: (data) => settingsService.toggleMaintenance(data),
    onSuccess: (res) => {
      invalidateSettings(queryClient);
      toastMutationSuccess(res, {
        fallbackMessage: "تم تحديث وضع الصيانة بنجاح",
      });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useTestEmail() {
  return useMutation<TestEmailResponse, Error, TestEmailRequest>({
    mutationFn: (data) => settingsService.testEmail(data),
    onError: (error) => handleApiError(error),
  });
}
